import React from "react";
import { TextField, Radio, RadioGroup, FormControlLabel } from "@mui/material";

export default function InputCard(props) {
  const {
    label,
    handleData,
    err,
    errTxt,
    arabicLabel,
    fontStyle,
    type,
    property,
  } = props;
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <h3 style={fontStyle}>{`${label}:`}</h3>
        <h3 style={fontStyle}>{`:${arabicLabel}`}</h3>
      </div>

      <TextField
        fullWidth
        label={label}
        id="fullWidth"
        onChange={(e) => handleData(e.target.value, property)}
        error={err}
        helperText={errTxt}
        type={type}
      />
    </>
  );
}
